import React from "react";
import { Box, Chip, useTheme } from "@mui/material";

// A row of clickable pills instead of a dropdown — an echelon's option list
// is always short (a handful of age groups, optionally "Todos"), so every
// choice can stay visible and directly tappable rather than hidden behind a
// Select the visitor has to open first.
const EchelonSelect = ({ echelonOptions, selected, onChange }) => {
    const theme = useTheme();

    return (
        <Box display="flex" flexWrap="wrap" gap={theme.spacing(1)}>
            {
                echelonOptions.map((option) => (
                    <Chip
                        key={option.id}
                        label={option.label}
                        clickable
                        onClick={() => onChange(option.id)}
                        color={selected === option.id ? "primary" : "default"}
                        variant={selected === option.id ? "filled" : "outlined"}
                        sx={{ fontWeight: selected === option.id ? "bold" : "normal" }}
                    />
                ))
            }
        </Box>
    );
}

export default EchelonSelect;
